import * as React from 'react';
import { withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';

import DataTable, {
    DataTableColumnProps,
    Renderer,
    Filterer,
    DataTableButton,
    DataTableButtonReset
} from 'src/components/common/DataTable';

import TableRequestDTO from 'src/models/datatable/TableRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import ActivityQuestionResponseDTO from 'src/models/activity/ActivityQuestionResponseDTO';
import ActivityApiController from 'src/api/ActivityApiController';
import { message, Button, Modal, Tooltip } from 'antd';


export interface ActivityQuestionResponsesProps extends LocalizeContextProps {
    activityId: number;
    activityQuestionId: number;
    isSurvey: boolean;
}

interface ActivityQuestionResponsesState {
    loading: boolean;
    tableRecords: ActivityQuestionResponseDTO[];
    formRedirect: boolean;
}

class ActivityQuestionResponses extends React.Component<ActivityQuestionResponsesProps, ActivityQuestionResponsesState> {
    private dataTableRef: DataTable<ActivityQuestionResponseDTO>;

    constructor(props: ActivityQuestionResponsesProps) {
        super(props);
        bindAllOfThis(this, ActivityQuestionResponses.prototype);

        this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
    }

    private deleteActivityQuestionResponse(activityQuestionResponseId: number): void {
        let ref = this.dataTableRef;
        let translate: (id: any) => any = this.props.translate;

        Modal.confirm({
            title: translate('admin.activityQuestionResponses.confirmDelete'),
            okText: translate('admin.common.confirmYes'),
            okType: 'danger',
            cancelText: translate('admin.common.confirmNo'),
            onOk() {
                ActivityApiController.deleteActivityQuestionResponse(activityQuestionResponseId).then(result => {
                    message.success(translate('admin.activityQuestionResponses.messageDelete'));
                    ref.refresh();
                }).catch(e => {
                    message.error(this.props.translate('admin.activityQuestionResponses.messageDeleteError'));
                });
            },
        });
    }

    private fetchData(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<ActivityQuestionResponseDTO>) => void): void {
        this.setState({ loading: true });

        ActivityApiController.getActivityQuestionResponseTableData(requestState, this.props.activityQuestionId)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                let tableRecords = results.data.results ? results.data.results : [];

                this.setState({
                    tableRecords: tableRecords,
                    loading: false
                });

                callback(results.data);
            });
    }

    private customTableColumns(): DataTableColumnProps<ActivityQuestionResponseDTO>[] {
        let editLink = (text, record: ActivityQuestionResponseDTO) => Routes.getRoute(Routes.ADMIN_ADD_EDIT_ACTIVITY_QUESTION_RESPONSE, this.props.activityId, this.props.activityQuestionId, record.activityQuestionResponseId);

        return [
            DataTable.StandardColumns.Text('admin.activityQuestionResponses.columnHeader1', 'responseText'),
            DataTable.StandardColumns.Text('admin.activityQuestionResponses.columnHeader2', 'displayOrder'),

            this.props.isSurvey ?
                DataTable.StandardColumns.Text('admin.activityQuestionResponses.columnHeader3', 'weight') :
                DataTable.StandardColumns.Boolean('admin.activityQuestionResponses.columnHeader4', 'isCorrect'),

            DataTable.StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit'),
            {
                columnProps: {
                    key: 'delete',
                    align: 'center',
                    width: 35,
                    render: (text, record, index) => {
                        return (
                            <Tooltip placement="bottom" title={this.props.translate('admin.common.deleteColumnHeader')} arrowPointAtCenter>
                                <Button shape="circle" icon="delete" onClick={() => this.deleteActivityQuestionResponse(record.activityQuestionResponseId)} />
                            </Tooltip>
                        );
                    }
                }
            }
        ];
    }

    render() {
        if (this.state.formRedirect) {
            return <Redirect to={Routes.getRoute(Routes.ADMIN_ADD_EDIT_ACTIVITY_QUESTION_RESPONSE, this.props.activityId, this.props.activityQuestionId, 0)} push />;
        }

        return (
            <div>
                <h2>{this.props.translate('admin.activityQuestionResponses.tableHeader')}</h2>
                <DataTable
                    ref={ref => this.dataTableRef = ref}
                    serverSide={true}
                    tableProps={{ rowKey: 'activityQuestionResponseId', loading: this.state.loading }}
                    columns={this.customTableColumns()}
                    data={this.state.tableRecords}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButton('admin.activityQuestionResponses.addButton', () => { this.setState({ formRedirect: true }); }),
                        new DataTableButtonReset()
                    ]} />
            </div>
        );
    }
}

export default withLocalize(ActivityQuestionResponses as any) as any;



// WEBPACK FOOTER //
// ./src/pages/admin/ActivityQuestionResponses.tsx